import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'rcn-survey-app',
  templateUrl: './survey-app.component.html',
  styleUrls: ['./survey-app.component.scss']
})
export class SurveyAppComponent implements OnInit {

  constructor() {}

  ngOnInit() {
    this.redirectToSurveyApp();
  }

  public redirectToSurveyApp() {
    location.assign(environment.rcnSurveyUrl);
  }
}
